
import {Component, Mixins, Ref, Watch} from "vue-property-decorator";
import Oran from "@/components/inputs/Oran.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import GenelIslemFormWizard, {GenelIslemEntity} from "@/components/forms/form-wizard/eicrapro/GenelIslemFormWizard.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import {IExcelDosya, Task} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import PersonelPicker from "@/components/pickers/PersonelPicker.vue";
import {VForm} from "@/types";
import {TahsilHarcOranlariniGetirRow} from "@/plugins/uyap-plugin/uyap/TahsilHarcOranlariniGetir";
import {
  HarcMasrafListItemBedelInterface,
  HarcMasrafListItemOranInterface,
  TahsilatNedenleriItem,
  TahsilHarcOranlariDB
} from '@/plugins/uyap-plugin/TahsilHarcOranlariDB';
import TakipRolleri from '@/plugins/uyap-plugin/takip_ac/parser/TakipRolleri';
import {HarcMasrafTypeEnum} from "@/plugins/uyap-plugin/uyap/enum/HarcMasrafTypeEnum";
import {HarcMasrafOdeTaskInterface} from "@/plugins/uyap-plugin/store/modules/TaskHandler/HarcMasrafOdeTaskHandler";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {IAvukatDosya} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";
import {TarafRol} from "@/plugins/uyap-plugin/enum/uyap/TarafRol";

@Component({
  components: {PersonelPicker, DeleteDialog, GenelIslemFormWizard, Tutar, Oran}
})
export default class HarcMasrafOdeFormWizard extends Mixins(SimpleInputMixin) {
  @Ref('form') readonly form!: VForm;
  @Ref('genel-form') genelForm!: GenelIslemFormWizard;

  harcMasrafTypeEnum = HarcMasrafTypeEnum;
  localValue: GenelIslemEntity = new GenelIslemEntity();
  data: Data = new Data();
  onFly = false;
  valid = false;
  isNullError = false;
  taraf = "";
  yargiGiderTuru = "";
  //@ts-ignore
  harcMasrafTuru: HarcMasrafListItemBedelInterface | HarcMasrafListItemOranInterface = {};
  tahsilatTuru: TahsilatNedenleriItem = new TahsilatNedenleriItem();
  vekaletPulu: any = TahsilHarcOranlariDB.PostaMasraflariList[0];
  tahsilHarcOranlari: TahsilHarcOranlariniGetirRow[] = [];
  odenecekHarcMasraflar: Array<HarcMasrafOdeTaskInterface> = [];

  stepperHeaders = [
    "Listelenecek Takipler",
    "Takipleri Seç",
    "Harç/Masraf Ödemesi Yap",
    "İşlemler Sıraya Alındı"
  ];

  get tarafItems() {
    return (new TakipRolleri()).takipRoller.filter((item) => {
      return item.rolID == 21 || item.rolID == 22
    })
  }

  yargiGiderTuruItems = [
    {isim: "Harç", value: 'H'},
    {isim: "Tahsilat", value: 'T'},
    {isim: "Pul", value: 'D'}
  ]

  harcMasrafHeaders = [
    {text: 'Harç/Masraf', value: 'tur'},
    {text: 'Taraf', value: 'tarafRolAdi'},
    {text: "Miktar", value: "adet"},
    {text: "Tutar", value: "tutar"},
    {text: "Toplam Tutar", value: "toplamTutar"},
    {text: "İşlemler", value: "actions", sortable: false, width: 50},
  ]

  get harcMasrafTuruItems() {
    return TahsilHarcOranlariDB.HarcMasrafList;
  }

  get tahsilatTuruItems() {
    return TahsilHarcOranlariDB.TahsilatNedenleriList;
  }

  get pulItems() {
    return TahsilHarcOranlariDB.PostaMasraflariList;
  }

  // Ham tutar (orn. 11.375) tabloda 2 haneye yuvarlanarak gosterilir
  tutarGoster(val: any) {
    return this.$helper.tutarStr(parseFloat(Number(val).toFixed(2)));
  }

  getHarcMasrafTuruLabel(item: any) {
    if (item.tur == "H")
      return 'Harç';
    else if (item.tur == "T")
      return 'Tahsilat';
    else if (item.tur == "D")
      return 'Pul';
    else
      return '';
  }

  @Watch('odenecekHarcMasraflar')
  onOdenecekHarcMasraflarChange() {
    this.isNullError = false;
  }

  @Watch('localValue.secilen_takipler', {deep: true})
  onSecilenTakiplerChange() {
    // Dosya secimi temizlendiginde taraf secimi de sifirlanir
    if (!this.localValue.secilen_takipler || this.localValue.secilen_takipler.length === 0)
      this.taraf = "";
  }

  mounted() {
    this.execTahsilHarcOranlariniGetir();
  }

  async execTahsilHarcOranlariniGetir() {
    this.tahsilHarcOranlari = await this.$uyap.TahsilHarcOranlariniGetir().run({});
  }

  yargiGiderTuruChange() {
    if (this.yargiGiderTuru == this.harcMasrafTypeEnum.PUL) {
      this.data = new Data();
      this.data = {...this.data, ...this.vekaletPulu};
      this.data.tutar = this.vekaletPulu.fiyati;
      this.data.toplamTutar = String(this.vekaletPulu.fiyati);
      this.data.hamToplamTutar = String(this.vekaletPulu.fiyati);
    }
    if (this.yargiGiderTuru == this.harcMasrafTypeEnum.TAHSILAT) {
      this.data = new Data();
      this.data = {...this.data, ...this.tahsilatTuru};
    }
    console.log("this.data yargiGiderTuruChange", this.data);
  }

  onHarcMasrafTuruChange() {
    console.log("onHarcMasrafTuruChange", this.harcMasrafTuru);
    this.data = {...this.data, ...this.harcMasrafTuru};
    console.log("this.data", this.data)
    if (this.data.harcmasrafBedelmiOranmi == "O") {
      this.data.tutarDisabled = false;
      this.data.pesinHarcDisabled = false;
      this.data.tutar = "";
    } else {
      this.data.tutar = this.data.harcMasrafBedel;
      this.data.tutarDisabled = true;
      this.data.pesinHarcDisabled = true;
    }
    this.data.toplamTutar = this.data.tutar;
    this.data.hamToplamTutar = this.data.tutar;
  }

  onTutarChange() {
    // Oran bazli harclarda ham (yuvarlanmamis) sonuc korunmali: UYAP pesin harci
    // yuvarlanmamis tutardan dusup 2 haneye en sonda yuvarliyor.
    // Orn. 500 x %2.275 = 11.375 -> 11.375 - 3.45 = 7.925 -> 7.92
    // Once yuvarlanirsa 11.38 - 3.45 = 7.93 cikiyor ve UYAP ile 1 kurus fark olusuyor.
    let hamTutar = parseFloat(this.data.harcMasrafOran) > 0
        ? parseFloat(this.data.tutar) * (parseFloat(this.data.harcMasrafOran) / 100)
        : parseFloat(this.data.tutar);
    if (isNaN(hamTutar)) {
      this.data.hamToplamTutar = "";
      this.data.toplamTutar = "";
      return;
    }
    this.data.hamToplamTutar = String(hamTutar);
    // Ekranda gosterilen deger yuvarli kalir
    this.data.toplamTutar = hamTutar.toFixed(2);
  }

  onAdd() {
    if (this.data.toplamTutar == "") {
      this.$toast.error("Lütfen Alanları Doldurunuz .");
      return;
    }
    if (!this.taraf || this.taraf === "") {
      this.$toast.error("Lütfen taraf seçiniz.");
      return;
    }
    let digerTurVarmi = this.odenecekHarcMasraflar.filter(x => x.tur != this.yargiGiderTuru);
    if (digerTurVarmi.length > 0) {
      this.$toast.warning('Aynı anda farklı yargı gideri türünde ödeme yapamazsınız.')
    } else {
      let tahsilatHarcOrani = 0;
      let tahsilatHarcKayitId = 0;
      let otomatikIliskilendirme = false;
      let id, adi;
      let roller = new TakipRolleri();
      if (this.yargiGiderTuru == this.harcMasrafTypeEnum.HARC_MASRAF) {
        id = this.harcMasrafTuru.harcmasrafKodStr;
        adi = this.harcMasrafTuru.harcMasrafAdi;
        // UYAP kurali (PRTL_GNL_1000555): cezaevi harci baska harc turleriyle
        // birlikte yatirilamaz, tek basina odenmeli.
        if (!this.cezaeviHarciKuraliUygun()) {
          this.$toast.error("Cezaevi harcı başka harç türleri ile beraber yatırılamaz, tek başına ödeyiniz.");
          return;
        }
      }
      if (this.yargiGiderTuru == this.harcMasrafTypeEnum.TAHSILAT) {
        id = this.tahsilatTuru.tahsilatKodu;
        adi = this.tahsilatTuru.tahsilatAciklama;
        // Harc orani sadece tahsilatHarcOrani=true olan turlerde gonderilir,
        // digerlerinde UYAP 0/false/0 bekliyor.
        if (this.tahsilatTuru.tahsilatHarcOrani) {
          if (!this.data.tahsilHarcOrani) {
            this.$toast.error("Lütfen harç oranı seçiniz.");
            return;
          }
          tahsilatHarcOrani = this.data.tahsilHarcOrani.oran;
          tahsilatHarcKayitId = this.data.tahsilHarcOrani.kayitId;
        }
        otomatikIliskilendirme = this.tahsilatTuru.otomatikIliskilendirme;
      }
      if (this.yargiGiderTuru == this.harcMasrafTypeEnum.PUL) {
        id = this.vekaletPulu.postaMasraflariID;
        adi = this.vekaletPulu.masrafAdi;
        let dahaOncePostaMasrafiEklenmismi = this.odenecekHarcMasraflar.find(x => x.tur == this.harcMasrafTypeEnum.PUL);
        if (dahaOncePostaMasrafiEklenmismi) {
          this.$toast.error("Bu ödeme türünden birden fazla eklenemez...");
          return;
        }
      }

      // tarafBilgileri (adSoyad/dosyaKisiId/kisiKurumId) her dosya icin farklidir,
      // burada secilen tek sey taraf rolu. Detaylari gorev calisirken
      // HarcMasrafOdeTaskHandler.harcMasrafHazirla() UYAP'tan dosya bazinda doldurur.
      // tutar UYAP'a gidecek birim tutardir; oran hesabinin ham sonucu korunur,
      // yuvarlama en sonda (gerekirse pesin harc dusuldukten sonra) yapilir.
      let birimTutar = parseFloat(this.data.hamToplamTutar || this.data.toplamTutar);
      let itemObject = {
        id: id,
        tur: this.yargiGiderTuru,
        adi: adi,
        adet: this.data.adet,
        tutar: birimTutar,
        toplamTutar: birimTutar * this.data.adet,
        tarafRolId: parseInt(this.taraf),
        tarafRolAdi: roller.find(parseInt(this.taraf))?.rolAdi,
        pesinHarcDusulsunMu: this.data.pesinHarcValue,
        // Peşin harç kutusu yalnızca oran bazlı harçlarda açılıyor; UYAP bu satırlarda
        // kutu işaretsiz olsa da dosyanın peşin harç tutarını gönderiyor.
        pesinHarcDusulebilirMi: !this.data.pesinHarcDisabled,
        pesinHarcTutari: 0,
        tarafBilgileri: null,
        tahsilatAciklama: this.data.aciklama ? this.data.aciklama : '-',
        tahsilatHarcOrani: tahsilatHarcOrani,
        tahsilatKayitId: tahsilatHarcKayitId,
        otomatikIliskilendirme: otomatikIliskilendirme,
      };
      this.odenecekHarcMasraflar.push(itemObject);
      this.data = new Data();
    }
  }

  // UYAP harcTip degerine gore cezaevi harclari: 15 = Cezaevi (Maktu), 4 = Cezaevi (Nispi)
  private cezaeviHarciMi(harcmasrafKodStr: any): boolean {
    let harc: any = TahsilHarcOranlariDB.HarcMasrafList.find((x: any) => x.harcmasrafKodStr == harcmasrafKodStr);
    return !!harc && [4, 15].indexOf(Number(harc.harcTip)) > -1;
  }

  // Cezaevi harci ne baska harclarin ustune ne de baska harc cezaevi harcinin ustune eklenebilir.
  cezaeviHarciKuraliUygun(): boolean {
    if (this.odenecekHarcMasraflar.length === 0)
      return true;
    if (this.cezaeviHarciMi(this.harcMasrafTuru.harcmasrafKodStr))
      return false;
    return !this.odenecekHarcMasraflar.some(x => this.cezaeviHarciMi(x.id));
  }

  onDelete(item: any) {
    this.odenecekHarcMasraflar.splice((this.odenecekHarcMasraflar.indexOf(item)), 1);
  }

  async createTask() {
    if (this.odenecekHarcMasraflar.length == 0)
      this.isNullError = true
    else if (this.form.validate()) {
      this.onFly = true;
      let tasks: Array<Task> = [];
      // @ts-ignore
      this.localValue.secilen_takipler.forEach((secilenTakip: IAvukatDosya | IExcelDosya) => {
        let task: Task = new Task()
        task.dosya_esas_no = secilenTakip.dosyaNo;
        task.birim_adi = secilenTakip.birimAdi;
        task.dosya_id = secilenTakip.dosyaId;
        task.birim_id = secilenTakip?.birimId;
        task.uyap_dosya_acilis_tarihi = secilenTakip.dosyaAcilisTarihi ? new Date(this.$uyapHelper.formatDate(secilenTakip.dosyaAcilisTarihi)).toString() : "";
        task.task_type_id = TaskTuru.harc_masraf_ode;
        task.data = this.odenecekHarcMasraflar;
        tasks.push(task);
      });
      let res = await this.$store.dispatch('postTasks', tasks);
      if (this.$store.getters.getAutoPlay)
        await this.$router.push(ProgramPaths.eicrapro + '/harc-masraf-ode-detay/' + res.data.id);
      else
        await this.$router.push(ProgramPaths.eicrapro + '/islemler');
    }
  }
}

class Data extends HarcMasrafListItemOranInterface {
  harcMasrafAdi: string = "";
  harcMasrafKod: string = "";
  harcTip: string = "";
  harcMasrafOran: string = "";
  harcMasrafBedel: string = "";
  adet: number = 1;
  tutar: string = "";
  // Ekranda gosterilen, 2 haneye yuvarlanmis tutar
  toplamTutar: string = "";
  // UYAP'a gidecek ham (yuvarlanmamis) tutar
  hamToplamTutar: string = "";
  tutarDisabled: boolean = true;
  pesinHarcDisabled: boolean = true;
  pesinHarcValue: boolean = false;
  aciklama: string = "";
  tahsilHarcOrani!: any;
  tahsilatHarcOrani!: any;
}

